"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ConfirmDialog", {
  enumerable: true,
  get: function () {
    return _ConfirmDialog.default;
  }
});
var _ConfirmDialog = _interopRequireDefault(require("./ConfirmDialog"));